import { useAuth0 } from '@auth0/auth0-react'
import { Trans } from '@lingui/macro'
import React from 'react'

const AccessDeniedPage: React.FunctionComponent = () => {
    const { isAuthenticated } = useAuth0()
    if (isAuthenticated) {
        return null
    } else {
        return (
            <div className='text-center'>
                <h1 className='text-xl font-bold mt-8 mb-4'>
                    <Trans>Access Denied</Trans>
                </h1>
                <p className='text-lg text-gray-600'>
                    <Trans>You do not have the required permissions.</Trans>
                </p>
            </div>
        )
    }
}

export default AccessDeniedPage
